import { Injectable } from '@angular/core';
import { AbstractSaveOneService } from 'src/app/modules/core/service/v2/service/save/abstractSaveOne.service';
import {MedicalMorphologySavePayload} from './medicalMorphologySave.payload';
import {MedicalMorphologyModel} from '../../model/medicalMorphology.model';
import {MedicalMorphologyRepository} from '../../../impl/service/ngrx/medicalMorphology.repository';
import {MedicalMorphologyDataServiceAdapter} from '../../../impl/service/ngrx/medicalMorphologyDataService.adapter';

@Injectable()
export class MedicalMorphologySaveService extends AbstractSaveOneService<MedicalMorphologyModel, MedicalMorphologySavePayload> {

    constructor(repository: MedicalMorphologyRepository, dataServiceAdapter: MedicalMorphologyDataServiceAdapter) {
        super(repository, dataServiceAdapter);
    }
}
